<template>
  <nav class="level">
    <div class="level-item has-text-centered">
      <div>
        <p class="heading">Following</p>
        <p class="title">{{ following }}</p>
      </div>
    </div>
    <div class="level-item has-text-centered">
      <div>
        <p class="heading">Followers</p>
        <p class="title">{{ followers }}</p>
      </div>
    </div>
  </nav>
</template>

<script>
import ApiUsers from '@/api/users'
export default {
  data () {
    return {
      following: 0,
      followers: 0
    }
  },
  created () {
    ApiUsers.get.relations().then(response => {
      this.following = response.body.following
      this.followers = response.body.followers
    })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/FeedRelations.vue